// extracted by mini-css-extract-plugin
export default {"wrapper":"orders-history_wrapper__TOZj1"};